/**
 * O `localStorage` para quem roda no boot do app.
 *
 * Embutido no portal do franqueado com cookies de terceiros bloqueados (Safari
 * em "bloquear todos os cookies", Chrome bloqueando cookies de terceiros), o
 * navegador nega o storage ao Sapron: só LER `window.localStorage` já lança
 * `SecurityError`. O app sempre monta mesmo assim, então todo acesso que roda
 * no boot (escopo de módulo, providers) passa por aqui.
 */

const SONDA = 'sapron-sonda-de-storage';

/** O `localStorage`, ou `undefined` quando o navegador nega acesso a ele. */
export function localStorageSeguro(): Storage | undefined {
  try {
    return window.localStorage;
  } catch {
    return undefined;
  }
}

/** O `sessionStorage`, ou `undefined` quando o navegador nega acesso a ele. */
export function sessionStorageSeguro(): Storage | undefined {
  try {
    return window.sessionStorage;
  } catch {
    return undefined;
  }
}

/**
 * Se dá para gravar sessão aqui. O handshake do portal e o login por senha
 * gravam a sessão no `localStorage`: sem ele, nenhum login funciona dentro da
 * moldura.
 */
export function storageDisponivel(): boolean {
  const storage = localStorageSeguro();
  if (!storage) return false;
  try {
    storage.setItem(SONDA, SONDA);
    storage.removeItem(SONDA);
    return true;
  } catch {
    return false;
  }
}
